<div class="expansion-conversion-bar" [class.-expanded]="expanded">
  <div class="expansion-conversion-bar-header">
    <div class="from">
      <span class="fa -toggle" [ngClass]="{ 'fa-chevron-right': !expanded, 'fa-chevron-down': expanded }" (click)="toggle()"></span>
      <div class="count">{{ lampGroup.lamps.length | number : '' : 'es' }}</div>
      <h4 class="model">{{ lampGroup.currentModel }}</h4>
    </div>
    <div class="transition">
      <span class="fa fa-arrow-right"></span>
    </div>
    <div
      class="to"
      [ngClass]="{
        'with-select-product':
          lampGroup.suggestedModel === 'null' ||
          lampGroup.suggestedModel === 'undefined' ||
          lampGroup.suggestedModel === null ||
          lampGroup.suggestedModel === undefined,
        manual: isManual
      }"
    >
      <h4
        class="model with-product"
        *ngIf="
          !(
            lampGroup.suggestedModel === 'null' ||
            lampGroup.suggestedModel === 'undefined' ||
            lampGroup.suggestedModel === null ||
            lampGroup.suggestedModel === undefined
          )
        "
        (click)="showProductDetail()"
        matTooltip="Leuchtendaten"
        tooltipClass="kp2-custom-tooltip"
        matTooltipPosition="above"
      >
        {{ lampGroupNewModelName }}
      </h4>
      <h4
        class="model"
        *ngIf="
          lampGroup.suggestedModel === 'null' ||
          lampGroup.suggestedModel === 'undefined' ||
          lampGroup.suggestedModel === null ||
          lampGroup.suggestedModel === undefined
        "
      >
        {{ lampGroupNewModelName }}
      </h4>
      <div
        class="controls"
        [ngClass]="{
          'with-select-product':
            lampGroup.suggestedModel === 'null' ||
            lampGroup.suggestedModel === 'undefined' ||
            lampGroup.suggestedModel === null ||
            lampGroup.suggestedModel === undefined
        }"
      >
        <a
          class="control -edit fa fa-eye"
          [ngClass]="{
            'with-product': !(
              lampGroup.suggestedModel === 'null' ||
              lampGroup.suggestedModel === 'undefined' ||
              lampGroup.suggestedModel === null ||
              lampGroup.suggestedModel === undefined
            )
          }"
          [class.-selected]="lampGroup.isHighlighted"
          (click)="toggleHighlight()"
          matTooltip="Hervorheben"
          tooltipClass="kp2-custom-tooltip"
          matTooltipPosition="above"
        ></a>
        <a
          class="control -edit fa fa-retweet"
          (click)="showAlternatives(lampGroup.lamps)"
          matTooltip="Alternativen"
          tooltipClass="kp2-custom-tooltip"
          matTooltipPosition="left"
        ></a>
        <a
          class="control -delete fa fa-trash-o"
          (click)="removeLampModel()"
          matTooltip="Löschen"
          tooltipClass="kp2-custom-tooltip"
          matTooltipPosition="left"
        ></a>
      </div>
    </div>
  </div>

  <div class="expansion-conversion-bar-content lamp-table" [class.-lamp-expanded]="lampExpanded">
    <div class="lamp" *ngFor="let lamp of lampGroup.lamps; trackBy: trackByFn">
      <h5 class="name" [attr.assetId]="lamp.assetId">Leuchtennr {{ lamp.bstNumber }}</h5>
      <div class="controls">
        <a class="fa fa-retweet" (click)="showAlternatives([lamp])" matTooltip="Alternativen" tooltipClass="kp2-custom-tooltip" matTooltipPosition="left"></a>
        <a class="fa fa-trash-o" (click)="removeLamp(lamp)" matTooltip="Löschen" tooltipClass="kp2-custom-tooltip" matTooltipPosition="left"></a>
      </div>
    </div>
    <a *ngIf="lampGroup.lamps.length > 5" class="lamp-toggle" (click)="toggleLampExpand()">{{ lampExpanded ? 'Weniger anzeigen' : 'Alle anzeigen' }}</a>
  </div>
</div>
